import { SplitTreatments, SplitClient } from '@splitsoftware/splitio-react'
import PropTypes from 'prop-types'
import { useSeller } from '@/contexts/seller'

const SplitControl = ({
  splitName,
  attributes = {},
  treatmentOff,
  children,
}) => {
  const { sellerData } = useSeller()

  const pocId =
    sellerData?.seller?.id ??
    JSON.parse(localStorage.getItem('SELLER_DATA'))?.seller?.id

  return (
    <SplitClient splitKey={process.env.SPLIT_IO_KEY}>
      <SplitTreatments
        names={[splitName]}
        attributes={{ poc_id: pocId, ...attributes }}
      >
        {({ treatments, isReady }) => {
          if (!isReady) return null
          return treatments[splitName].treatment === 'on'
            ? children
            : (treatmentOff ?? null)
        }}
      </SplitTreatments>
    </SplitClient>
  )
}

SplitControl.propTypes = {
  splitName: PropTypes.string.isRequired,
  treatmentOff: PropTypes.node,
  children: PropTypes.node.isRequired,
  attributes: PropTypes.object,
}

export default SplitControl
